<template>
  <div id="">
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="headerToken" placeholder="jira请求头"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="jiraTaskName" placeholder="jira任务名称开头"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="jiraEpic" placeholder="epic YYF-111"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="beginDate" placeholder="2023-01-01"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="endDate" placeholder="2023-12-31"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="el-form-button" type="primary" v-on:click="save">保存</el-button>
        </el-form-item>
      </el-form>
    </el-col>

  </div>
</template>

<script>
import {HttpResp} from '../../constant/index';
import {dslApi, tourApi} from '../../api/index';
import PageGroup from "../template/PageGroup";

export default {
  name: 'DslOpenApiSign',
  components: {PageGroup},
  data() {
    return {
      headerToken: '',
      jiraTaskName: '',
      jiraEpic: '',
      beginDate: '',
      endDate: ''
    }
  },
  mounted: function () {
  },
  computed: {

  },
  methods: {
    save() {
      let data = {
        "headerToken": this.headerToken,
        "jiraTaskName": this.jiraTaskName,
        "jiraEpic": this.jiraEpic,
        "beginDate": this.beginDate,
        "endDate": this.endDate
      }
      dslApi.createJiraTask(data).then(data => {
        if(data.code == HttpResp.SUCCUSS){
          this.$message({
            type: 'success',
            message: "保存成功"
          });
          this.loadLocation();
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
  }

}
</script>



// WEBPACK FOOTER //
// src/components/dsl/DslCreateJiraTask.vue